export default __webpack_public_path__ + "static/media/Group 3225@2x.4ac339e4.png";